export const SET_USERLIST_SHOW = "SET_USERLIST_SHOW";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const SET_UPLOADED_FILE = "SET_UPLOADED_FILE";
export const SET_CONTACT_LIST = "SET_CONTACT_LIST";
export const SET_CONTACT_LIST1 = "SET_CONTACT_LIST1";
export const SET_CONTACT_LIST2 = "SET_CONTACT_LIST2";
export const SET_AGENT_LIST = "SET_AGENT_LIST";
export const SET_DROPDOWN_AGENT_LIST = "SET_DROPDOWN_AGENT_LIST";
export const SET_EXTERNAL_CHAT_DATA = "SET_EXTERNAL_CHAT_DATA";
export const SET_MESSAGE = "SET_MESSAGE";
export const SET_CUSTOMER_TYPING = "SET_CUSTOMER_TYPING";
export const SET_CONTACT_LISTUPDATED = "SET_CONTACT_LISTUPDATED";
export const SET_CONTACT_LIST_UPDATED1 = "SET_CONTACT_LIST_UPDATED1";
export const SET_CHAT_SPINNER = "SET_CHAT_SPINNER";
export const SET_INTERNAL_CHAT_DATA = "SET_INTERNAL_CHAT_DATA";
export const SET_SEARCH_TERM = "SET_SEARCH_TERM";
export const SET_MSG_TONE = "SET_MSG_TONE";
export const SET_MSG_TONE2 = "SET_MSG_TONE2";
export const SET_CHAT_SESSION_ID = "SET_CHAT_SESSION_ID";
export const SET_DIALED_NUMBER_INC = "SET_DIALED_NUMBER_INC";
export const SET_AGENT_DIALED_NUMBER = "SET_AGENT_DIALED_NUMBER";
export const SET_SHOW_DIALED_NUMBER = "SET_SHOW_DIALED_NUMBER";
export const SET_SHOW_INCOMING_SCREEN = "SET_SHOW_INCOMING_SCREEN";
export const SET_VOICE_AVAILABLE = "SET_VOICE_AVAILABLE";
export const SET_CONSULTED_CONTACT_ID = "SET_CONSULTED_CONTACT_ID";
export const SET_CALL_LIST = "SET_CALL_LIST";
export const SET_CALL_CONTACTID = "SET_CALL_CONTACTID";
export const SET_VOICE_SESSION_ID = "SET_VOICE_SESSION_ID";
export const SET_SELETED_VOICE_SESSION_ID = "SET_SELETED_VOICE_SESSION_ID";
export const SET_SHOW_VOICE_CALL = "SET_SHOW_VOICE_CALL";
export const SET_VOICE_PLAT_FORM = "SET_VOICE_PLAT_FORM";
export const SET_WEB_RTC = "SET_WEB_RTC";
export const SET_END_CHAT_MODAL_DIALOG = "SET_END_CHAT_MODAL_DIALOG";
export const SET_SIDEBAR_VAL = "SET_SIDEBAR_VAL";
export const SET_VALUE = "SET_VALUE";
export const SET_SHOWING_STATUS = "SET_SHOWING_STATUS";
export const SET_SHOWING_STATUS_VOICE = "SET_SHOWING_STATUS_VOICE";
export const SET_SHOWING_STATUS_CLASS = "SET_SHOWING_STATUS_CLASS";
export const SET_READY_BUTTON = "SET_READY_BUTTON";
export const SET_SELECTED_EXTERNAL_CHAT_TYPE =
  "SET_SELECTED_EXTERNAL_CHAT_TYPE";
export const SET_ARRIVAL_MESSAGE = "SET_ARRIVAL_MESSAGE";
export const SET_SELECTED_MENU = "SET_SELECTED_MENU";
export const SET_CUSTOMER_TYPING_ID = "SET_CUSTOMER_TYPING_ID";
export const SET_CLI = "SET_CLI";
export const REPORT_AGENTLIST_LOADING = "REPORT_AGENTLIST_LOADING";
export const REPORT_AGENTLIST_SUCCESS = "REPORT_AGENTLIST_SUCCESS";
export const REPORT_AGENTLIST_ERROR = "REPORT_AGENTLIST_ERROR";
export const REPORT_SKILLSET_LOADING = "REPORT_SKILLSET_LOADING";
export const REPORT_SKILLSET_SUCCESS = "REPORT_SKILLSET_SUCCESS";
export const REPORT_SKILLSET_ERROR = "REPORT_SKILLSET_ERROR";
export const SET_EMAIL_LIST = "SET_EMAIL_LIST";
export const SET_SHOW_EMAIL_LIST = "SET_SHOW_EMAIL_LIST";
export const SET_SELECTED_MAIL = "SET_SELECTED_MAIL";
export const SET_MENTION_LIST = "SET_MENTION_LIST";
export const SET_MAIL_TYPE = "SET_MAIL_TYPE";
export const SET_EMAIL_LIST_OPTIONS = "SET_EMAIL_LIST_OPTIONS";
export const SET_FROM_EMAIL_LIST_OPTIONS = "SET_FROM_EMAIL_LIST_OPTIONS";
export const SET_EMAIL_TEMPLATE = "SET_EMAIL_TEMPLATE";
export const SET_SUPERVISORAPPROVE = "SET_SUPERVISORAPPROVE";
export const SET_EMAIL_ATTACHMENT = "SET_EMAIL_ATTACHMENT";
export const SET_COMPOSE_EMAIL_ATTACHMENT = "SET_COMPOSE_EMAIL_ATTACHMENT";
export const SET_FORWARDED_EMAIL_LIST = "SET_FORWARDED_EMAIL_LIST";
export const SET_CONTACT_LIST_LOADER = "SET_CONTACT_LIST_LOADER";
export const MISSED_CHATS = "MISSED_CHATS";
export const SET_ISBARGINCALL = "SET_ISBARGINCALL";
// CustomerPortal channel ------------------------------------------------------------------------------------------------------------

export const SET_SHOW_CHAT_FORM = "SET_SHOW_CHAT_FORM";
export const SET_SHOW_FORM = "SET_SHOW_FORM";
export const SET_CHAT_DATA = "SET_CHAT_DATA";
export const SET_AGENT_LEFT = "SET_AGENT_LEFT";
export const SET_CHAT_TYPE = "SET_CHAT_TYPE";
export const SET_TRANSLATION_LANGUAGE = "SET_TRANSLATION_LANGUAGE";

// CustomerPortal channel ------------------------------------------------------------------------------------------------------------
